module.exports = __webpack_public_path__ + "static/media/USG_Branding_Guide.1b0d6b8d.zip";